export const commonStyles = {
  container: {
    width: '100%',
    border: '1px solid',
    borderColor: 'divider',
    display: 'flex',
    flexDirection: 'column',
    height: 200,
  },
  searchField: {
    width: '100%',
    p: 0,
    m: 0,
    '& .MuiInputBase-root': {
      '& fieldset': { border: 'unset' },
      '& .MuiInputBase-input': { p: 0, m: 0, overflow: 'auto' },
    },
  },
  select: {
    borderRadius: 0,
    height: '100%',
    '& .MuiSelect-select': { py: 0, px: 1 },
    '& .MuiSvgIcon-root': { right: 0 },
    '& fieldset': { border: '1px solid', borderColor: 'divider' },
  },
  listItemText: {
    '& .MuiListItemText-primary': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
  listButton: {
    width: '100%',
    justifyContent: 'flex-start',
    padding: 0,
  },
  listItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 0.5,
  },
};
